import {
    Button,
    Checkbox,
    Dialog,
    IconButton,
    MinusIcon,
    Pane,
    PlusIcon,
    SearchInput,
    Strong,
    Table,
    Text,
    toaster
} from "evergreen-ui";
import React from "react";
import {createUseStyles} from "react-jss";
import {useDispatch} from "react-redux";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import {VirtualList} from "../../Utils/VirtualList";
import FormField from "../../Utils/FormField";
import {deletePrivilegeForRole, getAllRoles, getAllRolesForPrivilege, saveRolesForPrivilege} from "./PrivilegesApi";

const useStyles = createUseStyles({
    rulesWrapper: {
        display: 'grid',
        height: '100%',
        gridTemplateColumns: 'minmax(250px,300px) 1fr',
    },
    searchTableWrapper: {
        display: 'grid',
        height: '100%',
        gridTemplateRows: 'max-content 1fr',
        borderRight: '1px solid lightgray',
        paddingRight: '.5em',
    },
    rulesTableWrapper: {
        display: 'grid',
        height: '100%',
        gridTemplateRows: '1fr max-content',
        marginLeft: '.5em',
        rowGap: '.5em',
    },
    rulesTable: {
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        border: '1px solid #E4E7EB',
    },
});

export default function PrivilegesPage({type, isLoading, data,}) {
    const classes = useStyles();
    const tableList = data || [];
    const dispatch = useDispatch();

    const [roles, setRoles] = React.useState(null);
    const [searchText, setSearchText] = React.useState('');
    const [isShown, setIsShown] = React.useState(false);
    const [isFetch, setIsFetch] = React.useState(false);
    const isRegion = React.useMemo(() => type === 'region', [type]);
    const [selectedId, setSelectedId] = React.useState(null);
    const [onUpdate, setOnUpdate] = React.useState(false)

    const fetchRoles = React.useCallback( (id) => {
        setIsFetch(true);
        getAllRolesForPrivilege(id).then((res) => {
            setRoles(res.data)
            setIsFetch(false)
        }).catch(err => {
            toaster.danger(err.message)
            setIsFetch(false)
        })
    }, [dispatch]);

    const filterTableList = React.useMemo(() => tableList.filter(({ name }) => name.toUpperCase().includes(searchText.toUpperCase())), [searchText, tableList]);

    const onCheck = React.useCallback((e, index, right) => {
        const { checked } = e.target;

        setRoles((cur) => {
            const tmp = JSON.parse(JSON.stringify(cur));
            if (checked) {
                tmp[index].right = right;
            } else {
                if (right === "ADMIN"){
                    tmp[index].right = "WRITE";
                    return tmp
                }
                if (right === "WRITE") {
                    tmp[index].right = "READ";
                    return tmp
                }
            }
            return tmp;
        });
    }, []);

    function deleteRole(index, roleName) {
        setRoles((cur) => {
            const tmp = JSON.parse(JSON.stringify(cur));
            tmp.splice(index, 1);
            deletePrivilegeForRole(selectedId, roleName).then(() => {
                toaster.success("Роль успешно удалена! ")
            }).catch(() => toaster.danger("Не получилось удалить роль..."))
            return tmp;
        });

    }

    const saveRoles = React.useCallback( () => {
        setIsFetch(true);
        saveRolesForPrivilege(selectedId, roles).then(
            () => {
                setIsFetch(false)
                toaster.success('Роли успешно сохранены!')
            }
        ).then(() => {
            setIsFetch(false)
        })

    }, [dispatch, roles]);

    // ---- render ----

    function RoleRow(item, index) {
        console.log(item, index)
        return <Table.Row
                isSelectable
            >
                <Table.Cell>
                    <Text>
                        {item.roleName}
                    </Text>
                </Table.Cell>
                <Table.Cell>
                    <Checkbox disabled checked />
                </Table.Cell>
                <Table.Cell>
                    <Checkbox
                        checked={item.right === "ADMIN" || item.right === "WRITE" }
                        onChange={(e) => onCheck(e, index, "WRITE")}
                    />
                </Table.Cell>
                <Table.Cell>
                    <Checkbox
                        checked={item.right === "ADMIN"}
                        onChange={(e) => onCheck(e, index, "ADMIN")}
                    />
                </Table.Cell>
                <Table.Cell flexBasis={64} flexShrink={0} flexGrow={0}>
                    <IconButton
                        icon={MinusIcon}
                        intent="danger"
                        appearance="primary"
                        onClick={() => {
                            deleteRole(index, item.roleName)}
                        }
                    />
                </Table.Cell>
            </Table.Row>
    }

    const RolesList = React.useCallback(() => {
        if (isFetch) return <SuspenseSpinner />;
        if (!roles) return <Table.Row><Table.Cell><Text>{`Выберите привилегию слева`}</Text></Table.Cell></Table.Row>;
        if (!roles?.length) {
            return <Table.Row><Table.Cell><Text>Добавьте роль</Text></Table.Cell></Table.Row>;
        }

        return <Table>
            {
                roles.map((item, index) => (
                    <Table.Row
                        isSelectable
                    >
                        <Table.Cell>
                            <Text>
                                {item.roleName}
                            </Text>
                        </Table.Cell>
                        <Table.Cell>
                            <Checkbox disabled checked />
                        </Table.Cell>
                        <Table.Cell>
                            <Checkbox
                                checked={item.right === "ADMIN" || item.right === "WRITE" }
                                onChange={(e) => onCheck(e, index, "WRITE")}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <Checkbox
                                checked={item.right === "ADMIN"}
                                onChange={(e) => onCheck(e, index, "ADMIN")}
                            />
                        </Table.Cell>
                        <Table.Cell flexBasis={64} flexShrink={0} flexGrow={0}>
                            <IconButton
                                icon={MinusIcon}
                                intent="danger"
                                appearance="primary"
                                onClick={() => {
                                    deleteRole(index, item.roleName)}
                                }
                            />
                        </Table.Cell>
                    </Table.Row>
                ))
            }
        </Table>
        // return <VirtualList data={roles} row={RoleRow} />;
    }, [RoleRow, isFetch, isRegion]);

    return isLoading ? <SuspenseSpinner /> : (
        <Pane className={classes.rulesWrapper}>
            <Pane className={classes.searchTableWrapper}>
                <FormField label={'Привилегии'}>
                    <SearchInput placeholder={`Найти привилегию...`} width="100%" onChange={(e) => setSearchText(e.target.value)} />
                </FormField>
                {
                    !filterTableList?.length
                        ? <Table.Row><Table.Cell><Text>{'Нет привилегий'}</Text></Table.Cell></Table.Row>
                        : (
                            <VirtualList
                                data={filterTableList}
                                row={(item) => (
                                    <Table.Row
                                        key={item.id}
                                        isSelectable
                                        isSelected={item.id === selectedId}
                                        onClick={() => {
                                            fetchRoles(item.id);
                                            fetchRoles(item.id);
                                            setSelectedId(item.id);
                                        }}
                                    >
                                        <Table.Cell>
                                            <Text>
                                                {`${item.idx ? `${item.idx} - ` : ''}${item.name}`}
                                            </Text>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            />
                        )
                }
            </Pane>
            <Pane className={classes.rulesTableWrapper}>
                <Pane className={classes.rulesTable}>
                    <Table>
                        <Table.Head>
                            <Table.HeaderCell><Strong>Роль</Strong></Table.HeaderCell>
                            <Table.HeaderCell><Strong>Чтение</Strong></Table.HeaderCell>
                            <Table.HeaderCell><Strong>Запись</Strong></Table.HeaderCell>
                            <Table.HeaderCell><Strong>Админ</Strong></Table.HeaderCell>
                            <Table.HeaderCell flexBasis={64} flexShrink={0} flexGrow={0} />
                        </Table.Head>
                    </Table>
                    <RolesList />
                </Pane>
                <Pane justifySelf="end">
                    <Button
                        iconBefore={PlusIcon}
                        onClick={() => setIsShown(true)}
                        disabled={!roles || isFetch}
                        marginRight={8}
                    >
                        Добавить роль
                    </Button>
                    <Button
                        appearance="primary"
                        intent="success"
                        disabled={!roles || isFetch}
                        onClick={saveRoles}
                    >
                        Сохранить
                    </Button>
                </Pane>
                <DialogRoles isShown={isShown} setIsShown={setIsShown} regionRoles={roles} setRegionRoles={setRoles} />
            </Pane>
        </Pane>
    );
}

function DialogRoles({
                         isShown, setIsShown, regionRoles, setRegionRoles,
                     }) {
    const dispatch = useDispatch();
    const [allRoles, setAllRoles] = React.useState([]);
    const [searchText, setSearchText] = React.useState('');
    const [addRoles, setAddRoles] = React.useState([]);
    const [isFetching, setIsFetching] = React.useState(false);

    const fetchData = React.useCallback( () => {
        setIsFetching(true);
        getAllRoles().then((res) => {
            setAllRoles(res.data)
            setIsFetching(false)
        }).catch(err => {
            toaster.danger(err.message)
            setIsFetching(false)
        })
    }, [dispatch]);

    const onCheck = React.useCallback((e, role) => {
        const { checked } = e.target;
        setAddRoles((cur) => {
            const tmp = [...cur];
            if (checked) {
                tmp.push(role);
            } else {
                tmp.splice(tmp.findIndex((r) => r.id === role.id), 1);
            }
            return tmp;
        });
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    const filterRoles = React.useMemo(() => allRoles.filter((role) => role?.name && role.name.includes('RS_') && role.name.toUpperCase().includes(searchText.toUpperCase())), [allRoles, searchText]);

    return (
        <Dialog
            isShown={isShown}
            title="Добавить роль"
            onCloseComplete={() => setIsShown(false)}
            isConfirmLoading={isFetching}
            confirmLabel="Добавить"
            cancelLabel="Отмена"
            onConfirm={() => {
                setRegionRoles((cur) => {
                    const tmp = [...cur]
                    addRoles.forEach((role) => tmp.push(
                        {
                            roleName: role.name,
                            right: 'READ'
                        }
                    ))

                    return tmp
                });
                setIsShown(false);
            }}
        >
            <Table>
                <Table.Head>
                    <SearchInput
                        width="100%"
                        placeholder="Найти роль..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </Table.Head>
                <Table.Body>
                    {
                        !filterRoles.length
                            ? <Table.Row><Table.Cell><Text>Нет ролей</Text></Table.Cell></Table.Row>
                            : filterRoles.map((item) => (
                                <Table.Row key={item.id}>
                                    <Table.Cell>
                                        <Strong>{item.name}</Strong>
                                    </Table.Cell>
                                    <Table.Cell flexBasis={150} flexShrink={0} flexGrow={0}>
                                        <Checkbox checked={!!addRoles.find((role) => role.id === item.id)} onChange={(e) => onCheck(e, item)} />
                                    </Table.Cell>
                                </Table.Row>
                            ))
                    }
                </Table.Body>
            </Table>
        </Dialog>
    );
}



